<template>
<div>
    <v-layout v-if="configOK" align-start row wrap justify-center class="mt-4 blue darken-4" style="_background-color: #01579B">
        <v-flex flex xs6 sm8 md8 lg8>
            <v-layout align-start row wrap justify-start class="mt-0">
            <img class="menuLogo ml-0 mt-2" src="../assets/images/logoEurope.png" style="height: 130px" @click="clearAll()" />
            </v-layout>
        </v-flex>
         <v-flex flex xs6 sm4 md4 lg4>
            <v-layout align-center row wrap justify-end class="mt-0">
                <span class="bigtitle">{{configEvento.categoria}} </span>
            </v-layout>
        </v-flex>

        <v-flex flex xs12 sm12 md12 lg12>

            <table style="width:100%; margin-bottom: 600px" v-if="tabOk" class="mt-3">
                <tr v-for="n in parseInt(configEvento.num)" class="pa-1" style="width:100%">
                    <td width="10%" :class=" getStylePos(n) + 'distacco no-wrap pa-2 ma-2' " @click="executeCommand(n)">
                        <strong style="font-size:xx-large"> {{ n }} </strong>
                    </td>
                    <td v-if="isVisible(n)" colspan="2" class="cardUp pa-1" style="witdh: 100%">
                        <span style="float: left">
                            <small class="ml-0 mr-2"></small>
                            <country-flag :country="getItem(n).nazione" size="large" />&nbsp;&nbsp;
                            <strong>{{ getItem(n).cognome }}
                                {{ getItem(n).nome }} </strong>
                        </span>
                        <span class="mt-1 p-0" style="
                                                    float: right;
                                                    color: white;
                                                    margin-right: 10px;
                                                ">
                            <small class="ml-2"><span class="ml-2"> </span><span class="ml-2">{{
                                                     getItem(n).squadra
                                                }} </span> </small>
                        </span>
                    </td>
                    <td v-if="isVisible(n)" width="10%" :class="  'black white--text clock no-wrap pa-2 ma-0'">
                        <strong> {{ riduci(getItem(n).tempo) }}</strong>
                    </td>
                    <td v-if="!isVisible(n)" colspan="2" class="cardUp pa-1" style="witdh: 100%">

                    </td>
                    <td v-if="!isVisible(n)" width="10%" class="cardUp pa-1">
                        <strong> </strong>
                    </td>

                </tr>
            </table>
        </v-flex>
    </v-layout>

    <v-layout v-if="!configOK " align-start row wrap justify-center class="mt-4 ">
        <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
            <v-layout class="display-1 justify-center">LIVE NON CONFIGURATO</v-layout>
        </v-flex>
    </v-layout>
</div>
</template>

<script>
import helper from '../helper';
import dayjs from 'dayjs'

export default {
    components: {
        //      live: LiveRanking,
    },
    name: 'Stream',

    data() {
        return {
            items: [],
            itemsF: [],

            p: {},

            tabOk: true,

            num: 3,

            items3: [],

            categoria: '',

            compatta: true,
            categoriaSelected: 'TUTTE',
            sessoSelected: 'TUTTI',
            divisioneSelected: 'TUTTE',
            listaCategorie: [],
            listaSesso: ['TUTTI', 'MASCHI', 'FEMMINE'],
            filterToggle: false,
            filterPreferiti: false,
            listaPreferiti: {},

            searchText: '',

            raceID: null,
            raceTitle: '',

            connection: null,

            configEvento: {},
            elencoIscritti: [],
            tagFile: null,

            myInterval: null,
            sport: '',

            chipMap: {},
            mappaIntermedi: {},

            currentIndex: 1,
            listaIntermedi: [],

            stats: false,
            loaded: false,
            dettaglio: false,
            currentItem: null,
            currentRilevamenti: {},

            value: 0,
            bufferValue: 100,
            interval: 0,
            pause: false,
            indexTo: -1,

            multiDivisione: false,
            mappaDivisioni: {},
            listaDivisioni: [],

            mappaFiles: {},
            clockBatterie: {},

            local: undefined,
            showDivisione: false,
            showBatteria: false,
            showGap: false,
            showFrac: false,
            showTime: true,
            color: 'red',
            numFrac: 1,
            refreshData: 60000,
            refreshPage: 300000,

            showFrazRow: true,
            showTimeRow: true,

            numRilevamentiStep: 0,

            filtroDialog: false,

            warningDelta: 2,
            warningLaps: 5,
            onlyWarning: false,

            orderByField: null,
            direction: true,

            numRilevamentiStep: 0,

            raceTime: '00:00:00',

            addClockDialog: false,
            clockToAdd: "",
            rilevamentoSelected: undefined,
            rilevamentoSelectedTitle: undefined,
            rilevamentoSelectedType: undefined,

            configOK: false

        };
    },

    created() {
        window.addEventListener('keypress', this.doCommand);
    },
    destroyed() {
        window.removeEventListener('keypress', this.doCommand);
    },

    beforeDestroy() {
        clearInterval(this.myInterval);
        clearInterval(this.myInterval);
    },

    mounted() {
        //console.log(this.$route.params.sport);
        console.log(this.$route.params.raceID);
        this.raceID = this.$route.params.raceID;
        this.paramID = this.$route.params.id;

        this.local = this.$route.params.local;

        this.loadEvento();
    },

    methods: {

        loadEvento() {
            this.listaIntermedi = [];
            this.elencoIscritti = [];

            console.log(this.raceID);
            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
            //  if (this.local) _url = "/local/"+ this.raceID+"/localLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";
            console.log(_url);
            this.getRemoteService(_url).then((response) => {
                console.log(">>" + (response) + "<<");
                if (response !== '') {
                    this.configRace(response);
                } else {
                    //alert("Evento non configurato.");
                    this.configEvento = {}

                    if (this.local !== undefined) {
                        const toks = this.local.split(",");
                        toks.forEach(tok => {
                            if (tok.indexOf("=") !== -1) {
                                const keyval = tok.split("=");
                                this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                            }
                        })
                    }
                }
                this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';

                console.log(this.configEvento)

            }); //fine
        },

        configRace(response) {
            this.configEvento = this.properties2Object(response);
            this.configOK = true;

            if (this.local !== undefined) {
                const toks = this.local.split(",");
                toks.forEach(tok => {
                    if (tok.indexOf("=") !== -1) {
                        const keyval = tok.split("=");
                        this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                    }
                })
            }

            if (this.configEvento.num !== undefined) this.num = parseInt(this.configEvento.num);

            for (let i = 1; i <= this.num; i++) {
                this.p[i] = false;
            }

            this.raceTitle = this.configEvento['raceTitle'];

            const _filename = this.configEvento['filename'];

            const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=" + _filename + ".csv";
            //if (this.local) _url = "/local/"+ this.raceID+ "/localLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
            this.getRemoteService(_url).then((response) => {
                this.elencoIscritti = this.csvJSON(response);

                this.elencoIscritti.forEach(elem => {
                    if (elem.nazione && elem.nazione.length > 2) {
                        elem.nazione = elem.nazione.substring(0, 2).toLowerCase();
                    } else if (elem.nazione === undefined || elem.nazione === '') {
                        elem.nazione = 'it';
                    }

                    if (elem.pettorale !== undefined) {
                        elem.pett = elem.pettorale
                    } else if (elem.p !== undefined) {
                        elem.pett = elem.p
                    } else if (elem.dorsale !== undefined) {
                        elem.pett = elem.dorsale
                    } else if (elem.dors !== undefined) {
                        elem.pett = elem.dors
                    }

                })

            });
        },

        doCommand(e) {
            let cmd = String.fromCharCode(e.keyCode).toLowerCase();
            this.executeCommand(cmd)
        },

        executeCommand(cmd) {
            // alert(cmd);
            console.log(cmd)
            this.tabOk = false
            if (cmd == 'c') {
                for (let i = 1; i <= this.num; i++) {
                    this.p[i] = false;
                }
            } else {

                this.p[parseInt(cmd)] = !this.p[parseInt(cmd)];
            }

            this.tabOk = true
            console.log(this.p)
        },

        isVisible(index) {
            //console.log("is visible " + index)
            return this.p[index];
        },

        getStylePos(pos) {
            if (pos == 1) return 'yellow accent-2 black--text ';
            else if (pos == 2) return 'blue-grey lighten-4 black--text ';
            else if (pos == 3) return 'brown lighten-2 black--text ';
            else return this.color + ' darken-2 black--text ';
        },

        getItem(index) {
            //console.log("Item" + index)
            return this.elencoIscritti[parseInt(index) - 1];
        },

        clearAll() {
            this.executeCommand('c')

        }

    },
};
</script>

<style scoped>
td {
    height: 0px !important;
    _background-color: black
}

.distacco {
    text-align: center;
    color: white;
    font-style: italic;
    border-radius: 10px 0px 0px 10px;
    _border: 1px solid lightgray;
    _border-radius: 0px 7px 7px 0px;
    _font-weight: bold;
}

.bigtitle {
    text-align: center;
    font-size: xxx-large;
    color: orange;
    font-weight: bold;
}

strong {
    font-size: x-large;
}

.clock {
    background-color: #212121;
    text-align: center;
    color: white;
    font-style: italic;
    border-radius: 0px 10px 10px 0px;
}

.cardUp {
    background-color: #00B0FF;
    color: white;
    _border: 1px solid lightgray;
    _border-radius: 13px 0px 0px 0px;
}

</style>
